import React from 'react';
import styled from 'styled-components';

const PerformanceIndexDescriptionWrap = styled.div`
  margin-top: ${({ theme }) => theme.spacing02};
  .performance-index-title {
    font-weight: ${({ theme }) => theme.fontWeightBold};
    margin-bottom: ${({ theme }) => theme.spacing01};
    color: ${({ theme }) => theme.colorText70};
  }
  .performance-index-text {
    color: ${({ theme }) => theme.colorText50};
    margin-bottom: ${({ theme }) => theme.spacing02};
    line-height: ${({ theme }) => theme.lineHeightText};
  }

  .performance-index-color-indicator {
    height: ${({ theme }) => theme.spacing04};
    width: ${({ theme }) => theme.spacing04};
    margin-right: ${({ theme }) => theme.spacing01};
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
    border-radius: ${({ theme }) => theme.borderRadius};
  }

  .performance-index-value-indicator {
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spacing02};
  }

  .performance-index-value-title {
    color: ${({ theme }) => theme.colorText70};
    font-size: ${({ theme }) => theme.fontSize03};
    margin-bottom: ${({ theme }) => theme.spacing01};
  }
  .performance-index-value-range {
    color: ${({ theme }) => theme.colorText50};
  }
`;

export default function PerformanceIndexDescription({ title, text, values, legendImage }) {
  return (
    <PerformanceIndexDescriptionWrap key={title}>
      <div className="performance-index-title">{title}</div>
      <div className="performance-index-text">{text}</div>
      {legendImage ? (
        <img src={legendImage} alt="legend" style={{ height: '300px' }} />
      ) : (
        values.map((value) => (
          <div key={value.name} className="performance-index-value-indicator">
            <div style={{ background: value.hexColor }} className="performance-index-color-indicator"></div>
            <div>
              <div className="performance-index-value-title">{value.name()}</div>
              <div className="performance-index-value-range">{value.range()}</div>
            </div>
          </div>
        ))
      )}
    </PerformanceIndexDescriptionWrap>
  );
}
